import { render } from "./zqTopicCheck.vue?vue&type=template&id=379dd533&scoped=true"
import script from "./zqTopicCheck.vue?vue&type=script&lang=js"
export * from "./zqTopicCheck.vue?vue&type=script&lang=js"

import "./zqTopicCheck.vue?vue&type=style&index=0&id=379dd533&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379dd533"]])

export default __exports__